import anime from 'animejs/lib/anime.es.js';
import Swiper, { Navigation, Pagination } from 'swiper';
import UIkit, { modal } from 'uikit';
import IMask from 'imask';
import deviceType from './modules/deviceType';
import dynamicAdapt from './modules/dynamic_adapt';
import header from './modules/header';
import headerNavigation from './modules/headerNavigation';
import headerMenu from './modules/headerMenu';

window.addEventListener('DOMContentLoaded', () => {
  anime({
    targets: 'body',
    opacity: [0, 1],
    easing: 'easeInQuad'
  });

  const telephones = document.querySelectorAll('input[type="tel"]');

  telephones.forEach(tel => {
    IMask(
      tel, {
      mask: '+{38} (00) 000 - 00 - 00',
      lazy: false
    });
  });

  deviceType();
  dynamicAdapt();
  header();
  headerNavigation();
  headerMenu();

  Swiper.use([Navigation]);
  Swiper.use([Pagination]);

  const promoSlider = new Swiper('.promo__slider', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,

    slidesPerView: 1,
    spaceBetween: 16,

    breakpoints: {
      '320': {
        spaceBetween: 16
      },
      '1025': {
        spaceBetween: 24
      }
    },

    pagination: {
      el: '.promo__slider .slider-pagination',
      clickable: true
    }
  });

  const doctorsSlider = new Swiper('.doctors__slider', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 3,
    spaceBetween: 16,
    watchSlidesVisibility: true,
    autoHeight: true,

    breakpoints: {
      '320': {
        slidesPerView: 1,
        spaceBetween: 16
      },
      '415': {
        autoHeight: false,
        slidesPerView: 2
      },
      '769': {
        slidesPerView: 3
      },
      '1025': {
        spaceBetween: 24
      }
    },

    pagination: {
      el: '.doctors .slider-counter',
      type: 'fraction'
    },

    navigation: {
      nextEl: '.doctors .next',
      prevEl: '.doctors .prev'
    }
  });

  const reviewsSlider = new Swiper('.reviews__slider', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    slidesPerView: 3,
    spaceBetween: 16,
    watchSlidesVisibility: true,
    autoHeight: true,

    breakpoints: {
      '320': {
        slidesPerView: 1,
        spaceBetween: 16
      },
      '415': {
        autoHeight: false,
        slidesPerView: 2
      },
      '769': {
        slidesPerView: 3
      },
      '1025': {
        spaceBetween: 24
      }
    },

    navigation: {
      nextEl: '.reviews .next',
      prevEl: '.reviews .prev'
    }
  });

  if (document.querySelector('.footer__nav ul')) {
    const footerAccardeon = document.querySelector('.footer__nav ul');

    if (window.matchMedia('(max-width: 768px)').matches) {
      footerAccardeon.setAttribute('uk-accordion', 'multiple: true');
    }
  }

  if (document.querySelector('.btn_categories')) {
    const btnCategories = document.querySelector('.btn_categories');

    btnCategories.addEventListener('click', () => {
      const expanded = btnCategories.getAttribute('aria-expanded');

      if (expanded === 'true') {
        btnCategories.setAttribute('aria-expanded', 'false');
      } else {
        btnCategories.setAttribute('aria-expanded', 'true');
      }
    });
  }
});
